'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var config = {
  CDN_ASSET_HOST: 'https://s3.amazonaws.com/cdn.ifeis.net/'
};

exports.default = config;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/config.js
// module id = 616
// module chunks = 0